var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.995,
    height: 32,
    viewBox: "0 0 31.995 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#407fff;}.b{fill:#406aef;}.c{fill:#e3faff;}.d{fill:#48d8ff;}.e{fill:#43c5ff;}.f{fill:#ccf4ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.995,16A16,16,0,1,0,16,32,16,16,0,0,0,31.995,16Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.912,39.8a16,16,0,0,1-19.877,24.83A16,16,0,1,0,94.912,39.8Zm0,0",
    transform: "translate(-70.346 -37.313)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M203.473,134.762a1.577,1.577,0,0,0-1.577-1.577H199.66a9.179,9.179,0,0,0,.689-3.365c0-.047.01-.212.01-.249V129.5c-.047-1.534-.517-2-1.12-2.228a1.12,1.12,0,0,0-1.12,1.12v.112a3.471,3.471,0,0,1-.545,1.175l-4.11,4.157-.069.085-1.25,3.343,1.25,5.183a.284.284,0,0,0,.284.284h7.738a1.065,1.065,0,0,0,1.053-.9c.3-1.99,1-6.607,1-7.063Zm0,0",
    transform: "translate(-180.136 -119.316)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M142.232,231.127h-2.816a.893.893,0,0,1-.893-.893v-8.455a.892.892,0,0,1,.893-.893h2.816a.892.892,0,0,1,.893.893v8.455A.893.893,0,0,1,142.232,231.127Zm0,0",
    transform: "translate(-129.865 -207.081)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M142.232,344.432h-2.816a.893.893,0,0,1-.893-.893v1.682a.893.893,0,0,0,.893.893h2.816a.893.893,0,0,0,.893-.893v-1.682A.893.893,0,0,1,142.232,344.432Zm0,0",
    transform: "translate(-129.865 -322.068)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M220.645,221.9h-.289c-.015.139-.037.32-.065.536a8.216,8.216,0,0,1-8.147,7.164v1.561a.285.285,0,0,0,.284.285h7.738a1.066,1.066,0,0,0,1.053-.9c.3-1.99,1-6.607,1-7.063a1.577,1.577,0,0,0-1.577-1.577Zm0,0",
    transform: "translate(-198.885 -208.033)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.d149328b9c50c98a4a2ceedbe0e3a74e.svg";
export { ForwardRef as ReactComponent };